<template>
  <div>
    <div v-if="is_show">
      <div class="ivu-drawer-mask"></div>
      <div class="ivu-drawer-wrap">
        <div class="icon_sbUj3" @click="show(false)">&times;</div>

        <!-- 预览区域 -->
        <div class="img-view">
          <div
            class="img-box"
            :style="{ backgroundImage: `url(${showImg(curent.extension)})` }"
          ></div>
          <Button
            type="primary"
            class="download-btn"
            @click="downloadAttachment"
            v-permission="'edit'"
          >
            {{ $t('payroll.detail.down') }}
          </Button>
          <Button
            type="primary"
            class="view-btn"
            @click="onViewPdf"
            ghost
            v-if="curent.extension === 'pdf' || curent.extension === 'PDF'"
          >
            {{ $t('btn.preview') }}
          </Button>
        </div>

        <div class="toolbar_HPdpi">
          <div class="spanBlock__kMkB">
            <span class="ellipse_2lrF4">{{ curent.name }}</span>
          </div>
          <div class="toolbar_arrow_2m4cb">
            <a class="optIcon_3vNIN font-18" @click="change_page('-')">&lt;</a>
            <span>{{ curent_indx + 1 }} / {{ attachmentList.length }}</span>
            <a class="optIcon_3vNIN font-18" @click="change_page('+')">&gt;</a>
          </div>
          <div class="toolbar_action_1OK0Z"></div>
        </div>

        <div
          class="ivu-drawer ivu-drawer-right"
          style="width: 130px; z-index: 2000"
        >
          <div class="ivu-drawer-content">
            <div class="ivu-drawer-header">
              <div class="ivu-drawer-header-inner">Basic Drawer</div>
            </div>
            <div
              class="ivu-drawer-body humbnail_list_3kPmG"
              style="
                background-color: #0a0a0a;
                box-shadow: 0 0 18px rgba(0, 0, 0, 0.6);
                overflow-y: auto;
                overflow-x: hidden;
              "
            >
              <div
                class="thumbnail_list_3kPmG"
                @click="change_row(i)"
                v-for="(col, i) in attachmentList"
                :key="i"
              >
                <img
                  :src="col.url ? col.url : col.path"
                  :class="{ active: curent_indx === i }"
                  alt="employeeAttachments"
                  v-if="$_.includes(accepts, col.extension)"
                />
                <img
                  :class="{ active: curent_indx === i }"
                  :src="showImg(col.extension)"
                  alt="employeeAttachments"
                  v-else
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      is_show: false,
      curent_indx: 0,
      curent: null,
      accepts: ['png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG', 'jfif', 'JFIF'],
      images: [],
      attachmentList: [] // 可展示的附件列表
    };
  },
  methods: {
    onViewPdf() {
      window.open(this.curent.url ? this.curent.url : this.curent.path);
    },
    // 展示预览图片
    showImg(type) {
      const url = this.curent.url ? this.curent.url : this.curent.path;
      return _.includes(['xls', 'xlsx', 'pdf', 'doc', 'docx'], _.toLower(type))
        ? require(`@/assets/img/files/${_.toLower(type)}1.png`)
        : url;
    },

    // 遍历可预览列表
    loopViewList(data) {
      let list = [];
      for (let i of data) {
        if (i.children.length > 0) {
          for (let j of i.children) {
            list.push(j);
          }
        }
      }
      return list;
    },

    show(is_show, curent, e, file_name, childrenIndex) {
      this.is_show = is_show;
      if (e) {
        this.images = e;
        if (childrenIndex === undefined) {
          this.curent = e[curent];
          this.attachmentList = e;
        } else {
          this.curent = e[childrenIndex].children[curent];
          this.attachmentList = this.loopViewList(e);
        }
        this.curent_indx = curent;
      }
    },
    change_row(e) {
      this.curent = this.attachmentList[e];
      this.curent_indx = e;
    },

    // 下载附件
    async downloadAttachment() {
      this.sb_loading = true;
      const url = this.curent.url ? this.curent.url : this.curent.path;
      const res = await this.$http('get', url, {}, false, null, 'blob');
      this.$setEexlFileName(
        res.data,
        `${this.curent.name}.${this.curent.extension}`
      );
      this.sb_loading = false;
    },

    async _view() {
      try {
        this.sb_loading = true;
        let url = _.replace(this.curent.path, '/o/', '/pdf/');
        window.open(
          '/static/pdf/web/viewer.html?file=' + encodeURIComponent(url)
        );
        this.sb_loading = false;
      } catch (e) {
        this.$Message.error('文檔加載失敗!');
        this.sb_loading = false;
      }
    },

    getObjectURL(file) {
      let url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      }
      return url;
    },

    change_page(e) {
      if (e === '+') {
        if (this.curent_indx < this.attachmentList.length - 1) {
          this.curent_indx += 1;
        }
      } else {
        if (this.curent_indx > 0) {
          this.curent_indx = this.curent_indx - 1;
        }
      }
      this.curent = this.attachmentList[this.curent_indx];
    }
  }
};
</script>
<style lang="less">
.img-view {
  position: absolute;
  left: 200px;
  top: 100px;
  right: 300px;
  bottom: 100px;
  background: #fff;
  padding: 20px 20px 60px 20px;

  .img-box {
    width: 100%;
    height: 100%;
    margin: auto;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  .download-btn {
    float: right;
    margin-top: 12px;
  }

  .view-btn {
    float: right;
    margin: 12px 12px 0 0;
  }
}

.pdf_1X0ex {
  width: 520px;
  height: 320px;
  position: absolute;
  top: 50%;
  left: 50%;
  background: #fff;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 70px;
}

.thumbnail_list_3kPmG {
  margin: 10px 0;
  width: 90px;
  height: 60px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  object-fit: cover;

  img {
    opacity: 0.6;
    width: 100%;
    height: 100%;
    display: block;
    margin: auto;
  }
}
.spanBlock__kMkB {
  display: flex;
  align-items: center;
  width: 356px;
  .ellipse_2lrF4 {
    margin-left: 20px;
    margin-right: 20px;
    display: block;
    line-height: 50px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 160px;
  }
  .max_ibEKh {
    max-width: 180px;
  }
}
.icon_sbUj3 {
  position: absolute;
  right: 150px;
  top: 60px;
  text-align: center;
  cursor: pointer;
  z-index: 2999;
  color: #fff;
  font-size: 25px;
}

.toolbar_action_1OK0Z {
  min-width: 540px;
  height: 50px;
  display: flex;
  align-items: center;
  color: #fff;
  overflow: hidden;
}
.toolbar_HPdpi {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 130px);
  height: 50px;
  font-size: 16px;
  color: #fff;
  line-height: 50px;
  background-color: rgba(34, 34, 34, 0.88);
  z-index: 2000;
}
.toolbar_arrow_2m4cb {
  width: 200px;
  text-align: center;
  display: flex;
  align-items: center;
  .optIcon_3vNIN {
    position: relative;
    width: 70px;
    height: 100%;
    display: inline-block;
    text-align: center;
  }
}
.active {
  opacity: 1 !important;
}

.pic-center {
  width: 100%;
  height: calc(100% - 100px);
}

.main-img {
  display: block;
  width: 100%;
  height: calc(100% - 100px);
  object-fit: contain;
}
</style>
